import { format, isPast, endOfDay } from 'date-fns'

// Due dates are stored as a single timestamp. By convention, a due whose LOCAL
// time is exactly 00:00 means "date only" — the user picked a day but no
// specific time. Time is opt-in: create flows store midnight when no time is set.
export function isDateOnlyDue(due) {
    if (!due) return false
    const d = new Date(due)
    const localMidnight = d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0
    const utcMidnight = d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0
    return localMidnight || utcMidnight
}

// A timed due is overdue once its instant passes; a date-only due is overdue
// only after the whole day has ended (so "today, no time" is not overdue at noon).
export function isDueOverdue(due, isCompleted = false) {
    if (!due || isCompleted) return false
    const d = new Date(due)
    return isPast(isDateOnlyDue(due) ? endOfDay(d) : d)
}

// Format a due for display: date-only shows just the date; a timed due appends HH:mm.
export function formatDue(due, dateFmt = 'MMM d, yyyy') {
    if (!due) return ''
    const d = new Date(due)
    return isDateOnlyDue(due) ? format(d, dateFmt) : `${format(d, dateFmt)}, ${format(d, 'HH:mm')}`
}

// Build a due_date ISO string from a date (yyyy-MM-dd) + optional time (HH:mm).
// No time → date-only (local midnight). Returns null when no date is given.
export function buildDueIso(dateStr, timeStr) {
    if (!dateStr) return null
    const t = (timeStr && String(timeStr).trim()) ? String(timeStr).trim() : '00:00'
    return new Date(`${dateStr}T${t}:00`).toISOString()
}
